module.exports = __webpack_public_path__ + "static/media/dice-d6.2092691d.svg";